import { useEffect } from 'react'
import type { OperationStatus } from '../models/common/OperationStatus'
import { getRootStore } from '../stores/rootStore'
import { useEffectOnMapChange } from './DeepCompareEffectForMaps'
import type { NotificationLevel } from '../stores/NotificationStore'


export function showNotificationForStatus(operationStatus: OperationStatus, errorPrefix: string, successText?: string) {
  const notificationStore = getRootStore().notificationStore
  const operationSuccess = operationStatus.isSuccess
  useEffect(() => {
      if (operationStatus.error) {
        notificationStore.showOperationStatusNotification(operationStatus, `${errorPrefix}: ${operationStatus.error.message}`)
      }
      if (successText && operationSuccess) {
        notificationStore.showOperationStatusNotification(operationStatus, successText)
      }
    }, [operationStatus])    
}

export function showNotificationsForStatusMap(statuses: Map<string, OperationStatus>, errorPrefix: string, successText?: string) {
  const notificationStore = getRootStore().notificationStore
  
  useEffectOnMapChange(statuses, (statusKey, operationStatus) => {
    if (operationStatus.error) {
      notificationStore.showOperationStatusNotification(operationStatus, `${errorPrefix} ${statusKey}: ${operationStatus.error.message}`)
    }
    if (successText && operationStatus.isSuccess) {
      notificationStore.showOperationStatusNotification(operationStatus, successText)
    }
})
}

export function showNotificationForObject(message: string, level: NotificationLevel, notificationKey = '', object = {}) {
  const notificationStore = getRootStore().notificationStore

  notificationStore.showNotificationForObject(message, level, notificationKey, object)
}